import { ActionType } from './actions';
import { EngagementSubmissionData } from '@/generated/graphql';

export function adminSubmissionReducer<T extends EngagementSubmissionData>(
  state: T,
  action: ActionType<T>,
): T {
  if (action.type === 'PROPERTY_CHANGED') {
    return {
      ...state,
      [action.payload.key]: action.payload.value,
    };
  }
  return state;
}
